import React, { useRef } from 'react'
import NumberFormat from 'react-number-format'
import PropTypes from 'prop-types'
import Input from 'src/Components/Input'

const propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  onChangeValues: PropTypes.func
}

const defaultProps = {}

const NumberInput = React.forwardRef(
  ({ onChange, onChangeValues, ...restProps }, ref) => {
    const myRef = useRef(null)
    const inputRef = ref || myRef

    return (
      <NumberFormat
        customInput={Input}
        getInputRef={inputRef}
        onValueChange={values => {
          const target = inputRef.current
          if (target && onChange) {
            const event = new Event('change', { bubbles: true })
            const tracker = inputRef._valueTracker
            if (tracker) {
              tracker.setValue(values.value)
            }
            target.dispatchEvent(event)
            onChange(event)
          }

          if (onChangeValues) {
            onChangeValues(values)
          }
        }}
        {...restProps}
      />
    )
  }
)

NumberInput.propTypes = propTypes
NumberInput.defaultProps = defaultProps
NumberInput.displayName = 'NumberInput'

export default NumberInput
